import "./wrapper.sass";
import { useEffect, useState } from "react";
import { AddEditCardModal } from "../modals/CardModal.jsx";
import { CounterpartModal } from "../modals/CounterpartModal";
import { Pagination } from "../Pagination.jsx";
import { useDispatch } from "react-redux";
import { setIsClosed } from "../../actions/cards";
import React from "react";

const CardWrapper = ({
  search,
  data,
  setCards,
  titles,
  totalCount,
  perPage,
  currentPage,
  setCurrentPage,
  getRequest,
  dataType,
  setCounterparties,
}) => {
  const [cardModalIsActive, setCardModalIsActive] = useState(false);
  const [counterpartyModalIsActive, setCounterpartyModalIsActive] =
    useState(false);
  const [editingCard, setEditingCard] = useState({});
  const [editingCounterpart, setEditingCounterPart] = useState({});

  const dispatch = useDispatch();

  useEffect(() => {
    if (cardModalIsActive) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [cardModalIsActive]);

  const checkNumeric = (str) => {
    const numericRegex = /^[0-9.]+$/;

    return numericRegex.test(str);
  };

  const handleEditCard = (card) => {
    setEditingCard(card);
    setCardModalIsActive(true);
  };

  const handleChangeStatus = (card) => {
    const { id } = card;
    dispatch(setIsClosed(data, setCards, id));
  };

  const handleEditCounterpart = (counterpart) => {
    setEditingCounterPart(counterpart);
    setCounterpartyModalIsActive(true);
  };

  return (
    <>
      {counterpartyModalIsActive && (
        <CounterpartModal
          setIsActive={setCounterpartyModalIsActive}
          editingCounterpart={editingCounterpart}
          setCounterparties={setCounterparties}
          counterparties={data}
        />
      )}
      {cardModalIsActive && (
        <AddEditCardModal
          setModalIsActive={setCardModalIsActive}
          setEditingCard={setEditingCard}
          getRequest={getRequest}
          card={editingCard}
          cards={data}
          setCards={setCards}
          type="edit"
        />
      )}
      <div className="service__wrapper wrapper">
        {data?.map((column, i) => (
          <>
            <div
              key={Object.keys(column).length + "_" + i}
              style={{
                gridTemplateColumns: `30px repeat(${titles.length}, 1fr) 20px`,
              }}
              className="card"
            >
              {
                <p style={{ width: "40px", textAlign: "center" }}>
                  {i + 1 + perPage * currentPage}
                </p>
              }
              {Object.keys(column).map(
                (item, i) =>
                  titles.find((title) => title.name === item) && (
                    <div
                      key={item + "_" + i + "_" + column[item] + "_"}
                      className={"card__" + item}
                    >
                      {item === "poa" ? (
                        column[item] ? (
                          "Присутня"
                        ) : (
                          "Відсутня"
                        )
                      ) : item === "fop" ? (
                        column[item] ? (
                          "Так"
                        ) : (
                          "Ні"
                        )
                      ) : typeof column[item] == "boolean" ? (
                        <button
                          onClick={() => handleChangeStatus(column)}
                          className={column[item] ? "active" : null}
                        >
                          <span>{column[item] ? "Активно" : "Неактивно"}</span>
                          {column.isclosed ? (
                            <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              enableBackground="new 0 0 512 512"
                            >
                              <g>
                                <g>
                                  <path d="m409.6,197.3h-18v-50.6c0-74.8-60.8-135.7-135.6-135.7s-135.6,60.9-135.6,135.6v50.6h-17.9c-17.7,0-32.1,14.4-32.1,32.1v239.6c0,17.7 14.4,32.1 32.1,32.1h307.2c17.7,0 32.1-14.4 32.1-32.1v-239.6c-0.1-17.6-14.5-32-32.2-32zm-248.4-50.7c0-52.3 42.5-94.8 94.8-94.8 52.3,0 94.8,42.5 94.8,94.8v50.5h-189.6v-50.5zm239.6,313.6h-289.6v-222.1h289.7v222.1z" />
                                  <path d="m256,429.7c11.3,0 20.4-9.1 20.4-20.4v-52.6c0-11.3-9.1-20.4-20.4-20.4s-20.4,9.1-20.4,20.4v52.6c2.84217e-14,11.2 9.1,20.4 20.4,20.4z" />
                                </g>
                              </g>
                            </svg>
                          ) : (
                            <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              enableBackground="new 0 0 512 512"
                            >
                              <g>
                                <g>
                                  <path d="m375,11c-66.3,0-120.2,53.9-120.2,120.1v64.1h-177.4c-33.4,0-60.5,27.1-60.5,60.5v184.7c0,33.4 27.2,60.5 60.5,60.5h227.8c33.4,0 60.5-27.1 60.5-60.5v-184.6c0-33.4-27.1-60.5-60.5-60.5h-9.5v-64.1c0-43.7 35.6-79.3 79.3-79.3 43.7,0 79.3,35.6 79.3,79.3v84.5c0,11.3 9.1,20.4 20.4,20.4s20.4-9.1 20.4-20.4v-84.5c0.1-66.3-53.8-120.2-120.1-120.2zm-50.2,244.8v184.7c0,10.8-8.8,19.7-19.7,19.7h-227.7c-10.9,0-19.7-8.8-19.7-19.7v-184.7c0-10.9 8.8-19.7 19.7-19.7h227.8c10.8-2.84217e-14 19.6,8.8 19.6,19.7z" />
                                  <path d="m191.3,430c11.3,0 20.4-9.1 20.4-20.4v-40.1c0-11.3-9.1-20.4-20.4-20.4-11.3,0-20.4,9.1-20.4,20.4v40.1c-0.1,11.3 9.1,20.4 20.4,20.4z" />
                                </g>
                              </g>
                            </svg>
                          )}
                        </button>
                      ) : checkNumeric(column[item]) ? (
                        parseFloat(column[item]).toLocaleString("uk-UA", {
                          style: "decimal",
                          maximumFractionDigits: 2,
                        }) + ` грн.`
                      ) : (
                        String(column[item]).replace("Моно ", "")
                      )}
                    </div>
                  )
              )}
              <button
                className="edit"
                onClick={() =>
                  dataType === "counterparties"
                    ? handleEditCounterpart(column)
                    : handleEditCard(column)
                }
              >
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.1213 2.70705C19.9497 1.53548 18.0503 1.53547 16.8787 2.70705L15.1989 4.38685L7.29289 12.2928C7.16473 12.421 7.07382 12.5816 7.02986 12.7574L6.02986 16.7574C5.94466 17.0982 6.04451 17.4587 6.29289 17.707C6.54127 17.9554 6.90176 18.0553 7.24254 17.9701L11.2425 16.9701C11.4184 16.9261 11.5789 16.8352 11.7071 16.707L19.5556 8.85857L21.2929 7.12126C22.4645 5.94969 22.4645 4.05019 21.2929 2.87862L21.1213 2.70705ZM18.2929 4.12126C18.6834 3.73074 19.3166 3.73074 19.7071 4.12126L19.8787 4.29283C20.2692 4.68336 20.2692 5.31653 19.8787 5.70705L18.8622 6.72357L17.3068 5.10738L18.2929 4.12126ZM15.8923 6.52185L17.4477 8.13804L10.4888 15.097L8.37437 15.6256L8.90296 13.5112L15.8923 6.52185ZM4 7.99994C4 7.44766 4.44772 6.99994 5 6.99994H10C10.5523 6.99994 11 6.55223 11 5.99994C11 5.44766 10.5523 4.99994 10 4.99994H5C3.34315 4.99994 2 6.34309 2 7.99994V18.9999C2 20.6568 3.34315 21.9999 5 21.9999H16C17.6569 21.9999 19 20.6568 19 18.9999V13.9999C19 13.4477 18.5523 12.9999 18 12.9999C17.4477 12.9999 17 13.4477 17 13.9999V18.9999C17 19.5522 16.5523 19.9999 16 19.9999H5C4.44772 19.9999 4 19.5522 4 18.9999V7.99994Z"
                    fill="#000000"
                  />
                </svg>
              </button>
            </div>
          </>
        ))}

        {search.trim().length === 0 && (
          <Pagination
            totalCount={totalCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            perPage={perPage}
          />
        )}
      </div>
    </>
  );
};

export default CardWrapper;
